import { reactive } from '@vue/composition-api';
export default function useImgFallback(_ref) {
  var src = _ref.src,
      errorSrc = _ref.errorSrc,
      alt = _ref.alt;
  var imgInfo = reactive({
    src: '',
    alt: ''
  });

  if (!src && !errorSrc) {
    imgInfo.alt = alt || '';
    return imgInfo;
  }

  var img = new Image();
  var step = 0;
  var steps = [function () {
    if (errorSrc) {
      img.src = errorSrc;
    } else {
      imgInfo.alt = alt || '';
    }
  }, function () {
    imgInfo.alt = alt || '';
  }];

  img.onerror = function () {
    var _steps$step;

    (_steps$step = steps[step]) === null || _steps$step === void 0 ? void 0 : _steps$step.call(steps);
    step++;
  };

  img.onload = function () {
    imgInfo.src = img.src;
  };

  if (src) {
    img.src = src;
  } else if (errorSrc) {
    step = 1;
    img.src = errorSrc;
  }

  return imgInfo;
}